import { countryToIso } from "../sanitize/foreignAddress";

export function formatDate(dateInput: string | Date | null): string {
  if (!dateInput) return ""; // Return empty if no date is provided
  const date = new Date(dateInput);
  return date.toISOString().split("T")[0]; // Returns YYYY-MM-DD
}

export function getValidCountryCode(countryName: string): string {
  const countryCodes: { [key: string]: string } = {
    CANADA: "CA",
    MEXICO: "MX",
    "UNITED KINGDOM": "UK",
    GERMANY: "GM",
    FRANCE: "FR",
    JAPAN: "JA",
    CHINA: "CH",
    INDIA: "IN",
    BRAZIL: "BR",
    AUSTRALIA: "AS",
    "UNITED STATES": "US",
    ARGENTINA: "AR",
    ITALY: "IT",
    SOUTH_KOREA: "KR",
    RUSSIA: "RU",
    SPAIN: "ES",
    SWEDEN: "SE",
    NETHERLANDS: "NL",
    BELGIUM: "BE",
    SWITZERLAND: "CH",
    AUSTRIA: "AT",
    NORWAY: "NO",
    DENMARK: "DK",
    FINLAND: "FI",
    PORTUGAL: "PT",
    POLAND: "PL",
    GREECE: "GR",
    IRELAND: "IE",
    SOUTH_AFRICA: "ZA",
    NEW_ZEALAND: "NZ",
    ISRAEL: "IL",
    EGYPT: "EG",
    SINGAPORE: "SG",
    THAILAND: "TH",
    MALAYSIA: "MY",
    PHILIPPINES: "PH",
    INDONESIA: "ID",
    VIETNAM: "VN",
    TURKEY: "TR",
    SAUDI_ARABIA: "SA",
    UNITED_ARAB_EMIRATES: "AE",
    QATAR: "QA",
    KUWAIT: "KW",
    OMAN: "OM",
    BAHRAIN: "BH",
    LEBANON: "LB",
    JORDAN: "JO",
    IRAQ: "IQ",
    KENYA: "KE",
    TANZANIA: "TZ",
    UGANDA: "UG",
    NIGERIA: "NG",
    ETHIOPIA: "ET",
    GHANA: "GH",
    COTE_D_IVOIRE: "CI",
    COLOMBIA: "CO",
    PERU: "PE",
    CHILE: "CL",
    PARAGUAY: "PY",
    BOLIVIA: "BO",
    URUGUAY: "UY",
    VENEZUELA: "VE",
    PANAMA: "PA",
    COSTA_RICA: "CR",
    GUATEMALA: "GT",
    HONDURAS: "HN",
    NICARAGUA: "NI",
    EL_SALVADOR: "SV",
    DOMINICAN_REPUBLIC: "DO",
    CUBA: "CU",
    HAITI: "HT",
    BELIZE: "BZ",
    BARBADOS: "BB",
    BERMUDA: "BM",
    JAMAICA: "JM",
    ANTIGUA_AND_BARBUDA: "AG",
    GRENADA: "GD",
    ST_LUCIA: "LC",
    ST_KITTS_AND_NEVIS: "KN",
    TRINIDAD_AND_TOBAGO: "TT",
    ST_VINCENT_AND_THE_GRENADINES: "VC",
    ARUBA: "AW",
    BONAIRE: "BQ",
    CURACAO: "CW",
    SINT_MAARTEN: "SX",
    ANGUILLA: "AI",
    MONACO: "MC",
    LUXEMBOURG: "LU",
    MALTA: "MT",
    ANDORRA: "AD",
    SAN_MARINO: "SM",
    VATICAN_CITY: "VA",
    MOLDOVA: "MD",
    ARMENIA: "AM",
    GEORGIA: "GE",
    ALBANIA: "AL",
    MACEDONIA: "MK",
    BOSNIA_AND_HERZEGOVINA: "BA",
    MONTENEGRO: "ME",
    KOSOVO: "XK",
    SERBIA: "RS",
    CROATIA: "HR",
    SLOVENIA: "SI",
    SLOVAKIA: "SK",
    LATVIA: "LV",
    ESTONIA: "EE",
    LITHUANIA: "LT",
    ICELAND: "IS",
    CYPRUS: "CY",

    ROMANIA: "RO",
    BULGARIA: "BG",
    HUNGARY: "HU",

    BELARUS: "BY",
    UKRAINE: "UA",
  };

  // Prefer the authoritative IRS CountryType code (schema-loaded); fall back to the legacy map,
  // then a best-effort 2-letter code. NEVER throw — applyForeignAddresses normalizes the recipient
  // CountryCd to the correct IRS code anyway, and XSD validation flags any truly-invalid country,
  // so one unmapped country name must not abort the entire chunk.
  return (
    countryToIso(countryName) ||
    countryCodes[String(countryName ?? "").toUpperCase()] ||
    String(countryName ?? "").replace(/[^A-Za-z]/g, "").slice(0, 2).toUpperCase()
  );
}